import dataApi from "./api/dataApi";

export default dataApi;
